"use client";

import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { DEFAULT_VALUES, NEWSLETTER_SCHEMA_EN } from "./FormSchema";
import PrimaryButton from "../../Atoms/Buttons/PrimaryButton";
import NewPrimaryButton from "../../Atoms/Buttons/NewPrimaryButton";
import NewPrimaryButtonWrapper from "../../Atoms/Buttons/NewPrimaryButtonWrapper";
import {
    EMAIL_FIELD_NAME,
    EMAIL_TEXT,
    SUBSCRIBE_TEXT,
    THANK_YOU_TEXT,
    UNORDERED_LIST_CLASS,
    getThankYouText,
    NewLetterApiCall,
} from "./constants";
import {
    ARABIC,
    SUBMIT_TYPE,
    SIGN_UP_ENDPOINT,
    TAKE_STYLE_QUIZ,
    TAKE_STYLE_QUIZ_AR,
} from "../../../public/Constants/EnumConstants";
import {
    NewInputField,
    NewInputFieldWithButton,
} from "../../Atoms/Inputs/NewInputField";
import { sendGTMEvent } from "@next/third-parties/google";
import { GoogleTagManagerEvents } from "../../../common";

const NewsletterForm2 = ({ buttonAgainstField }) => {
    const [formSubmitted, setFormSubmitted] = useState(false);
    const {
        handleSubmit,
        register,
        formState: { errors },
        reset,
        getValues,
    } = useForm({
        mode: "onSubmit",
        reValidateMode: "onBlur",
        defaultValues: DEFAULT_VALUES,
        resolver: yupResolver(NEWSLETTER_SCHEMA_EN),
    });

    const onsubmit = async (e) => {
        sendGTMEvent({
            event: GoogleTagManagerEvents.formInteractions,
            interaction_type: "submitted",
            interaction_item: "NewsLetterForm",
        });
        setFormSubmitted(true);

        // const response = await NewLetterApiCall(e?.EmailSubscribe);
        // if (response.status != 200) {
        //     setFormSubmitted(true);
        //     reset();
        // }
    };
    const InputFieldComponent = () => {
        return buttonAgainstField ? (
            <>
                <NewInputFieldWithButton
                    buttonText={SUBSCRIBE_TEXT}
                    errors={errors}
                    field={EMAIL_FIELD_NAME}
                    name={EMAIL_FIELD_NAME}
                    placeholder={EMAIL_TEXT}
                    register={register}
                />
            </>
        ) : (
            <>
                <NewInputField
                    errors={errors}
                    field={EMAIL_FIELD_NAME}
                    // label={getNewsletterTextTwo(lang)}
                    name={EMAIL_FIELD_NAME}
                    placeholder={EMAIL_TEXT}
                    register={register}
                />

                <NewPrimaryButton
                    text={SUBSCRIBE_TEXT}
                    type={SUBMIT_TYPE}
                    className="w-[100%] mt-1"
                />
            </>
        );
    };

    return (
        <form onSubmit={handleSubmit(onsubmit)}>
            {!formSubmitted ? (
                <InputFieldComponent />
            ) : (
                <div>
                    <p className={UNORDERED_LIST_CLASS}>{THANK_YOU_TEXT}</p>
                    <br />
                    <NewPrimaryButtonWrapper
                        text={TAKE_STYLE_QUIZ}
                        href={SIGN_UP_ENDPOINT}
                    />
                </div>
            )}
        </form>
    );
};

export default NewsletterForm2;
